import { Point } from "PosterEditor/model/poster-types";
import { Rect } from "PosterEditor/model/poster-types";

// Function to calculate the perpendicular offset point
export const getOffsetPoint = (
  lastPoint: Point,
  thisPoint: Point,
  nextPoint: Point,
  offset: number
): Point => {
  // const angle = Math.atan2(
  //   nextPoint.y - lastPoint.y,
  //   nextPoint.x - lastPoint.x
  // ); // Angle of tangent
  // return {
  //   x: thisPoint.x + offset * Math.sin(angle),
  //   y: thisPoint.y - offset * Math.cos(angle),
  // };
  const dx = nextPoint.x - thisPoint.x;
  const dy = nextPoint.y - thisPoint.y;
  const length = Math.sqrt(dx * dx + dy * dy);
  return {
    x: (offset * dy) / length,
    y: (-offset * dx) / length,
  };

  // const angle = Math.atan2(dy, dx);
  // return {
  //   x: thisPoint.x + offset * Math.sin(angle),
  //   y: thisPoint.y - offset * Math.cos(angle),
  // };
};

export const pointIsInsideRect = (
  point: { x: number; y: number },
  rect: { x: number; y: number; width: number; height: number }
): boolean => {
  return (
    point.x >= rect.x &&
    point.x <= rect.x + rect.width &&
    point.y >= rect.y &&
    point.y <= rect.y + rect.height
  );
};

export const resizeRectFromCenter = (rect: Rect, size: number): Rect => {
  return {
    x: rect.x - size / 2,
    y: rect.y - size / 2,
    width: rect.width + size,
    height: rect.height + size,
  };
};
